/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import ProductPartners from "./ProductPartners";

export default ProductPartners;
